// *********************************
// Code generated by sdkgen - edited by you!
//
// This module contains any hand-written services or other things your module
// needs to share with applications that use it.
// *********************************
import { NgModule } from '@angular/core';
import { ContractBillingInternalModule } from './_internal/contract-billing.module';
import { ContractBillingService } from './contract-billing.service';

@NgModule({
  imports: [ContractBillingInternalModule],
  providers: [
    ContractBillingService,
  ],
  declarations: [],
  exports: [],
  entryComponents: []
})
export class ContractBillingModule {}
